import { useTranslation } from "react-i18next";
import { GoogleDocsTerms } from "../../components/common/GoogleDocsTerms";

export const TermAndCondition = () => {
  const { t } = useTranslation();
  return <GoogleDocsTerms type="term" title={t("terms_conditions")} />;
};
